<template>
  <div id="IA">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'IA',
  components: {
  },
  created() {
  }
}
</script>

<style>
#IA{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%
}
</style>
